import { MeetingStateInitial } from "../models/meetModal";
import { MeetActions } from "../interface/meetReducerTypes"

const initialState = {
  meetingDetails: {
    alternate_host: [],
    calender_type: '',
    description: '',
    dial_in_countries: [],
    duration_minutes: 0,
    end_timestamp: 0,
    invite_url: '',
    is_alternate_host: false,
    is_attended: 0,
    is_cancelled: 0,
    is_host_myvideo: false,
    is_participant_invite_guest: false,
    is_participant_join_bef_host: false,
    is_participant_mute_entry: false,
    is_participant_video: false,
    is_participant_waiting_room: false,
    is_record_meeting: false,
    is_use_personal_meeting_id: false,
    joining_option_type: '',
    meeting_id: '',
    participants: [],
    password: '',
    personal_meeting_id: '',
    rrule: '',
    save_template: false,
    sip_id: '',
    start_timestamp: 0,
    status: '',
    timezone: '',
    title: '',
    uuid: '',
    time: '',
    is_custom_password: '',
    recurrence: '',
    isScreenshareStarted: false,
    isWhiteboardStarted: false
  },
  sockmeetDetails: {
    isHostjoined: false,
    isParticipantjoinbefhost: false,
    restrictScreenShare: false,
    chatEnabled: false,
    chatSetting: "",
    meetStartTime: 0,
    lockMeeting: false,
    renameingParticipant: false,
    isWhiteboardStarted: false,
    isScreenshareStarted: false,
    meetingId: '',
    meetingName: '',
    screenShare: false,
    waitingRoom: false,
    devicesInfo: {},
    conversations: [],
    generalSetting: {
      isChat: false,
      isScreenShare: false,
      renameThemselves: false,
      lockMeeting: false,
      is_participant_unmute_themselves: false,
      isWaitingroom: false,
      is_participant_mute_entry: false,
      shareOptions: {
        howManyPart: "",
        startShare: "",
        whoShare: ""
      }
    },
    isHostAudioMute: false,
    hostDetails: {
      isRecordingAllowed: false,
      isHost: false,
      mute: false,
      name: '',
      pined: false,
      removeFromMeeting: false,
      video: false,
      conId: '',
      deviceid: '',
      isGuest: false,
      ext: 0,
      hand: false,
      isAlternateHost: false,
      moveToWaitingRoom: false,
      profileImg: '',
      roleType: 0,
      sipId: '',
      status: '',
      waiting_retrycount: 0,
      recordingStatus: "stop",
      isActive: false,
      // audioPitch:1,
      isMirror: true,
      isScreenshare: false,
      closedCaption: false
    }
  }, workcontact: [],
  teamContacs: [],
  favContacts: [],
  isTeamContactLoading: false,
  activeParticipantList: [],
  activeParticipantListWH: [],
  waitingRoomList: [],
  recordingEnabledList: [],
  ccUserList: [],
  muteStatus: false,
  currdeviceid: "",
  currdeviceinfo: {
    isRecordingAllowed: false,
    isHost: false,
    mute: false,
    name: '',
    pined: false,
    removeFromMeeting: false,
    video: false,
    conId: '',
    deviceid: '',
    isGuest: false,
    ext: 0,
    hand: false,
    isAlternateHost: false,
    moveToWaitingRoom: false,
    profileImg: '',
    roleType: 0,
    sipId: '',
    status: '',
    waiting_retrycount: 0,
    recordingStatus: "stop",
    isActive: false,
    // audioPitch:1,
    isMirror: true,
    isScreenshare: false,
    closedCaption: false
  },
  isError: { message: '' },
  isSuccess: { message: '' },
  isLoading: false,
  thankYou: false,
  isFailure: false,
  connstatus: "",
  arrowKey: false,
  draggableScreen: false,
  audioStream: "",
  videoStream: "",
  pin: [],
  activeSpeaker: {},
  gridViewSize: 7,
  joinUser: false,
  openWR: false,
  retryCount: 0,
  unmuteReq: false,
  recordAllowed: false,
  showRecording: false,
  closeCaptionData: [],
  // captionStatus: "",
  // captionBoolean:false,
  // ccSpeaker: [],
  // speakerName:'',
  recordPopup: false,
  muteToggle: false,
  videoToggle: true,
  videoToggleDelay: false,
  AskToJoinButtonStatus: false,
  unmuteReqParticipant: false,
  videoUnHideReq: false,
  hostReqVideoAudioKey: "",
  unmuteParticipant: {
    isRecordingAllowed: false,
    isHost: false,
    mute: false,
    name: '',
    pined: false,
    removeFromMeeting: false,
    video: false,
    conId: '',
    deviceid: '',
    isGuest: false,
    ext: 0,
    hand: false,
    isAlternateHost: false,
    moveToWaitingRoom: false,
    profileImg: '',
    roleType: 0,
    sipId: '',
    status: '',
    waiting_retrycount: 0,
    recordingStatus: "stop",
    isActive: false,
    // audioPitch:1,
    isMirror: true,
    isScreenshare: false,
    closedCaption: false
  },
  sendunmuteReq: false,
  instatus: "",
  ssKey: false,
  ssCancel: false,
  ssPermit: false,
  ssOpen: false,
  meetingTitleStatus: false,
  meetStatus: "",
  ssDetails: {},
  currentPage: 0,
  startPage: 0,
  autoDraggable: false,
  currentScreenParticipant: [],
  browserVersion: '107',
  browserType: 'Chrome',
  iceState: false,
  isSocketInit: false,
  isTransoportClose: false,
  isInstantMeetingLoader: false,
  reactionsCount: {
    ohreaction: 0,
    thumbsup: 0,
    wavehand: 0,
    heart: 0,
    tearsofjoy: 0
  },
  clientDomain: {
    urapi: "https://qaurapi.worktual.co.uk",
    videosgw: "videosgw.worktual.co.uk",
    meetsocket: "https://urmeet-io.worktual.co.uk",
    videoturnv4: "turn:audioturnv4.worktual.co.uk:3478",
    videoturnv6: "turn:audioturnv6.worktual.co.uk:3478"
  },
  hideSelf: false,
  hideNonVideo: false,
  agentvideo: false,
  announcementMsg: "",
  customerDetails: {},
  componentState: "internalChat",
  customerComponentState:"",
  recTimer:0,
  pauseTime:0,
  elapsedTime:0,
  fullScreenAgent:false,
  fullScreenCustomer:false,
  sms_data:[],
  videoCallDetails:  
  {  CallHistoryId: 0,
  sessionId: "",
  sessionStartTime: 0,
  sessionEndTime: 0,
  customerNumber:0,
  domainId: 0,
  IsInBound: 0,
  dialDuration: 0,
  disconnectedBy: 0,
  queueDuration:0,
  assignedTo:0,
  assignedBy: 0,
  assignedOn: 0,
  calledNumber: 0,
  waitDuration: 0,
  recordingTypeId: 0,
  CustomerId:0,
  voicemailUrl: "",
  callDuration: "",
  callBack: 0,
  CallBackCallHistoryId: 0,
  voiceMailDuration: 0,
  createdAt: "",
  updatedAt: "",
  callCost: 0,
  IsAbandoned: 0,
  businessStartTime: 0,
  businessEndTime:0,
  showState: false,
  queueName: "",
  type:"video",
  interactions: [],
  isInteractionView:false,
  calledPersonDetails:{
    coid: 0,
    firstName: "",
    lastName: "",
    phoneNumber:JSON.stringify([]),
    email: JSON.stringify([]),
    accountNumber: [],
    tags: [],
    location: null,
    address:  null,
    country:  null,
    state:  null,
    city: null,
    postalCode:  null,
    facebook:  null,
    instagram:  null,
    twitter:  null,
    voiceBiometric: null,
    domainId: 0,
    mergeCustomer: 0,
    blockCustomer: 0,
    doNotDisturb: 0,
    blockCustomerReq: 0,
    doNotDisturbReq: 0,
    type:  null,
    currentCustomerNumber: null,
    customerType: null,
    timeZone: null,
    cookiesId:  null,
    startTime:0,
    vmSettings:{}
  }},
  vmTransferDropdown:false,
  vm_acd_event:0,
  vmTransfer:false,
  vmTransferDetails:{},
  vmTransferTimer:0,
  vmTransferStartTime:0,
  cSatOpen:false
};

export const meetingReducer = (state: MeetingStateInitial = initialState, action: MeetActions) => {
  switch (action.type) {
    case 'UPDATE_MEET_DETAILS':
      return {
        ...state,
        meetingDetails: action.payload.meetingDetails
      };
    case 'SOCKET_MEETING_DETAILS':
      return {
        ...state,
        sockmeetDetails: action.payload.sockmeetDetails,
        activeParticipantList: action.payload.activeParticipantList,
        activeParticipantListWH: action.payload.activeParticipantListWH,
        waitingRoomList: action.payload.waitingRoomList,
        recordingEnabledList: action.payload.recordingEnabledList,
        currdeviceid: action.payload.currdeviceid,
        currdeviceinfo: action.payload.currdeviceinfo,
        ccUserList: action.payload.ccUserList,
      };
    case 'UPDATE_WORK_CONTACT':
      return {
        ...state, workcontact: action.payload.workcontact
      };

    case 'UPDATE_FAV_CONTACT':
      return {
        ...state, favContacts: action.payload.favContacts
      };
    case 'TEAM_CONTACT':
      return {
        ...state, teamContacs: action.payload.teamContacs, isTeamContactLoading: action.payload.isTeamContactLoading
      };
    case 'SOCKET_ERROR':
      //console.log('isError--->', action.payload.isError);
      return {
        ...state, isError: action.payload.isError, isSuccess: action.payload.isSuccess
      };
    case 'SOCKET_LOADING':
      return {
        ...state, isLoading: action.payload.isLoading
      };
    case 'UPDATE_AUDIO_STREAM':
      return {
        ...state, audioStream: action.payload.audioStream
      };
    case 'UPDATE_VIDEO_STREAM':
      return {
        ...state, videoStream: action.payload.videoStream
      };
    case 'SOCK_THANK':
      return {
        ...state, thankYou: action.payload.thankYou, connstatus: action.payload.connstatus,
        isFailure: action.payload.isFailure,cSatOpen:action.payload.cSatOpen
      };

    case 'UPDATE_ACTIVE_PARTICIPANT':
      return {
        ...state,
        activeParticipantList: action.payload.activeParticipantList
      };
    case 'PIN_UPDATE':
      return {
        ...state, pin: action.payload.pin, activeSpeaker: action.payload.activeSpeaker
      };
    case 'SOCKET_JOIN':
      return {
        ...state, joinUser: action.payload.joinUser
      };
    case 'OPEN_WR':
      return {
        ...state, openWR: action.payload.openWR
      };
    case 'UNMUTE_REQ':
      return {
        ...state, unmuteReq: action.payload.unmuteReq
      };
    case 'UNMUTE_PART_REQ':
      return {
        ...state, unmuteReqParticipant: action.payload.unmuteReqParticipant,
        unmuteParticipant: action.payload.unmuteParticipant,
        sendunmuteReq: action.payload.sendunmuteReq
      };
    case 'RECORD_UPDATE':
      return {
        ...state, recordAllowed: action.payload.recordAllowed
      };
    case 'SHOW_RECORDING':
      return {
        ...state, showRecording: action.payload.showRecording
      };
    case 'RECORD_POPUP':
      return {
        ...state, recordPopup: action.payload.recordPopup
      };
    case 'TOGGLE_VIDEO':
      return {
        ...state, videoToggle: action.payload.videoToggle
      };
    case 'TOGGLE_VIDEO_DELAY':
      return {
        ...state, videoToggleDelay: action.payload.videoToggleDelay
      };
    case 'TOGGLE_AUDIO':
      return {
        ...state, muteToggle: action.payload.muteToggle
      };

    case 'MUTE_STATUS':
      return {
        ...state, muteStatus: action.payload.muteStatus
      };
    case 'UPDATE_IN_STATUS':
      return {
        ...state, instatus: action.payload.instatus
      };
    case 'UPDATE_CONN_STATUS':
      return {
        ...state, connstatus: action.payload.connstatus
      };
    case 'UPDATE_ARROW_KEY':
      return {
        ...state, arrowKey: action.payload.arrowKey
      };

    case 'FULL_SCREEN':
      return {
        ...state, fullScreenAgent: action.payload.fullScreenAgent,fullScreenCustomer:action.payload.fullScreenCustomer
      };
    case 'UPDATE_MEET_STATUS':
      return {
        ...state, meetStatus: action.payload.meetStatus
      }
    case 'AUTO_DRAGGABLE':
      return {
        ...state, autoDraggable: action.payload.autoDraggable
      }
    case 'CURRENT_PARTICIPANT':
      return {
        ...state, currentScreenParticipant: action.payload
      }
    case 'BROWSER_TYPE':
      return {
        ...state, browserVersion: action.payload.browserVersion, browserType: action.payload.browserType
      }
    case 'ICE_CONNECTION_STATE':
      return {
        ...state, iceState: action.payload.iceState
      }
    case 'IS_SOCKET_INIT':
      return {
        ...state, isSocketInit: action.payload.isSocketInit
      }
    case 'IS_TRANSPORT_CLOSE':
      return {
        ...state, isTransoportClose: action.payload.isTransoportClose
      }
    case 'UPDATE_INSTANT_LOADER':
      return {
        ...state, isInstantMeetingLoader: action.payload.isInstantMeetingLoader
      };
    case 'ASK_TO_JOIN_BUTTON':
      return {
        ...state, AskToJoinButtonStatus: action.payload.AskToJoinButtonStatus
      };
    case 'SSO_TOKEN_CLIENT_DOMAIN':
      return {
        ...state, clientDomain: action.payload.clientDomain
      }
    case 'AGENT_VIDEO':
      console.log("action.payload.agentvideo >>>>>>>>>", action.payload)
      return {
        ...state, agentvideo: action.payload.agentvideo, customerDetails: action.payload.customerDetails
      }
    case 'QUEUE_ANNOUNCEMENT':
      console.log("action.payload", action.payload);
      return {
        ...state, announcementMsg: action.payload.announcementMsg
      }

    case 'MEETING_CONTROL_OPEN':
      console.log("action.payload", action.payload);
      return {
        ...state, componentState: action.payload.componentState
      }
      case 'CUSTOMER_CONTROL_OPEN':
        console.log("action.payload",action.payload);
        return {
          ...state,customerComponentState:action.payload.customerComponentState
        }
        case 'REC_TIMER':
          return {
            ...state,recTimer:action.payload.recTimer,pauseTime:action.payload.pauseTime,elapsedTime:action.payload.elapsedTime
                  }
        case 'SMS_DETAILS':
          return {
            ...state,sms_data:action.payload.sms_data
                  }
        case 'VIDEO_CALL_DETAILS':
          return {
            ...state,videoCallDetails:action.payload.videoCallDetails
          }
        case 'RESET_VM_DETAILS':
          return{
            ...state,videoCallDetails:initialState.videoCallDetails
          }
        case 'SET_DURATION':
          return{
            ...state,startTime:action.payload.startTime
          }

        case 'VM_SETTINGS':
          return{
            ...state,vmSettings:action.payload.vmSettings
          }
        case 'VM_TRANSFER':
          return {
            ...state,vmTransferDropdown:action.payload.vmTransferDropdown,vmTransfer:action.payload.vmTransfer,vm_acd_event:action.payload.vm_acd_event,vmTransferDetails:action.payload.vmTransferDetails
            }
        case 'VM_TRANSFER_TIME':
          return {
            ...state,vmTransferTimer:action.payload.vmTransferTimer,vmTransferStartTime:action.payload.vmTransferStartTime
            }

    default:
      return state;
  }
};

